export default "__VITE_ASSET__CXsPebWB__"